import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM8.05 15.54C7.72 13.64 9.16 12 11 12c.35 0 .69.07 1 .18V8c0-1.1.9-2 2-2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v7.03c-.02 1.82-1.66 3.26-3.55 2.92-1.21-.21-2.2-1.2-2.4-2.41z"
}), 'MusicVideoRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MusicVideoRounded.js
// module id = 4973
// module chunks = 2